import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class extends Route {
  @service studentEvents!: StudentEventsService

  queryParams = {
    category: {
      replace: true,
    },
    sort: {
      replace: true,
    },
    pageNumber: {
      replace: true,
    },
    perPage: {
      replace: true,
    },
  }

  async model() {
    const { scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const product: LegacyProductMs = 'maths'
    const { mentalMinuteStudent } = await this.makeStatsRequests(product, statsScope, period)

    return {
      scopedStudents,
      mentalMinuteStudent,
    }
  }

  async makeStatsRequests(product: LegacyProductMs, scope: SchoolScope | StudentsScope, period: NormalizedInterval) {
    return RSVP.hash({
      mentalMinuteStudent: await this.studentEvents.mentalMinuteStudent(product, scope, period),
    })
  }
}
